"use strict";
export const COLORS = [
  "#FF6384",
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FF9F40",
  "#8AC249",
  "#EA526F",
  "#23B5D3",
  "#279AF1"
];
